"use client";

import {
  CATEGORY_QUERY_STRING_KEY,
  TOPIC_QUERY_STRING_KEY,
} from "../../../helpers/contactSettings";
import { notNullish } from "../../../helpers/notNullish";
import { useSearchParams } from "next/navigation";
import React, { Suspense } from "react";

/* Shows a loading fallback only when the SideMenu filters have changed */
export const SearchParamsSuspense = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const searchParams = useSearchParams();
  const uuids = [
    searchParams?.getAll(CATEGORY_QUERY_STRING_KEY),
    searchParams?.getAll(TOPIC_QUERY_STRING_KEY),
  ]
    .flat()
    .filter(notNullish);

  return <Suspense key={uuids.join(",")}>{children}</Suspense>;
};
